import * as xlsx from 'xlsx';
import { appName } from '../config/uri';

const generateXlsx = (name, body) => {
  const workbook = xlsx.utils.book_new();

  workbook.Props = {
    Title: `${appName}`,
    Subject: `${appName}`,
    Author: `${appName}`,
    CreatedDate: new Date(),
  };

  workbook.SheetNames.push(`${appName}`);

  const workbook_sheet = xlsx.utils.aoa_to_sheet(body);

  workbook.Sheets[`${appName}`] = workbook_sheet;

  const file = xlsx.write(workbook, { bookType: 'xlsx', type: 'binary' });

  const buf = new ArrayBuffer(file.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < file.length; i++) view[i] = file.charCodeAt(i) & 0xff;

  const blob = new Blob([buf], { type: 'application/octet-stream' });

  save(name, blob);
};

const save = (name, blob) => {
  return navigator.msSaveBlob
    ? navigator.msSaveBlob(blob, name)
    : saveGenericBrowser(blob, name);
};

const saveGenericBrowser = (blob, name) => {
  const a = document.createElement('a');

  return 'download' in a && !!download(a, name, URL.createObjectURL(blob));
};

const download = (a, name, url) => click(asDownload(a, name, url));

const asDownload = (a, name, url) => {
  a.setAttribute('href', url);
  a.setAttribute('download', name);
  a.style.visibility = 'hidden';

  return a;
};

const click = (el) => {
  document.body.appendChild(el);
  el.click();

  return document.body.removeChild(el);
};

export default generateXlsx;
